<template>
  <b-modal
    @show="limparFormulario"
    @hidden="limparFormulario"
    size="lg"
    hide-footer
    id="modal-salvar-pessoa"
    centered
    :title=" idPessoa == 0 ? 'Cadastrar Nova Pessoa': 'Atualizar Pessoa'"
  >

  <div class="d-flex">
	<b-spinner v-show="carregandoBuscarPessoa" variant="primary" class="mx-auto"></b-spinner>
  </div>

    <b-form v-if="!carregandoBuscarPessoa" class="d-flex flex-column" style="gap:5px">
      <div class="d-flex gap-sm">
        <div class="d-flex gap-sm">
          <label>Pessoa Jurídica:</label>
          <input
            @input="limparFormulario"
            type="radio"
            value="pessoaJuridica"
            v-model="tipoPessoa"
            :disabled="idPessoa != 0"
          />
        </div>
        <div class="d-flex gap-sm">
          <label>Pessoa Física:</label>
          <input
            @input="limparFormulario"
            type="radio"
            value="pessoaFisica"
            v-model="tipoPessoa"
            :disabled="idPessoa != 0"
          />
        </div>
      </div>
      <div>
        <hr />
      </div>
      <b-form-row>
        <b-col md="6" sm="12" v-if="tipoPessoa == 'pessoaFisica'">
          <label>Nome Completo:</label>
          <input class="form-control" type="text" v-model="pessoa.nome" />
        </b-col>
		<b-col md="6" sm="12" v-if="tipoPessoa == 'pessoaFisica'">
          <label>Cpf:</label>
          <input
            class="form-control"
            type="text"
            v-mask="'###.###.###-##'"
            v-model="pessoa.cpf"
			placeholder="Ex: 000.000.000-00"
          />
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col sm="12" md="6" v-if="tipoPessoa == 'pessoaJuridica'">
          <label>Razão Social:</label>
          <input
            class="form-control"
            type="text"
            v-model="pessoa.razaoSocial"
          />
      </b-col>
	    <b-col sm="12" md="6" v-if="tipoPessoa == 'pessoaJuridica'">
          <label>Cnpj:</label>
          <input
            class="form-control"
            type="text"
            v-mask="'##.###.###/####-##'"
            v-model="pessoa.cnpj"
			placeholder="Ex: 00.000.000/0000-00"
          />
        </b-col>
      </b-form-row>
	  <b-form-row>
		<b-col md="6">
            <label>Estado:</label>
            <select v-model="pessoa.estado" class="form-control">
                <option value selected disabled>Selecione</option>
                <option v-for="(estado, index) in estados" :key="index" :value="estado.nome">{{ estado.nome }}</option>
            </select>
		</b-col>
		<b-col md="6">
            <label>Município:</label>
			<auto-complete-cidade :value="pessoa.cidade" @cidadeSelecionada="selecionaCidade($event)"/>
		</b-col>
	  </b-form-row>
	  <b-form-row v-if="tipoPessoa == 'pessoaFisica' && !pessoa.funcionarioPrimeseg">
		<b-col md="6" sm="12">
			<label>Tipo Específico:</label>
			<select v-model="pessoa.tipoEspecifico" class="form-control">
                <option value="" selected disabled>Selecione</option>
                <option value="CEI">CEI</option>
                <option value="CAEPF">CAEPF</option>
                <option value="CNO">CNO</option>
            </select>
		</b-col>
		<b-col md="6" sm="12">
			<label>Código {{ pessoa.tipoEspecifico ? pessoa.tipoEspecifico : "" }}:</label>
			<span id="disabled-wrapper" tabindex="0">
				<input type="text" class="form-control" v-model="pessoa.codigo" :disabled="!pessoa.tipoEspecifico">
		  	</span>
			<b-tooltip v-if="!pessoa.tipoEspecifico && !pessoa.funcionarioPrimeseg" target="disabled-wrapper">Selecione um Tipo Específico</b-tooltip>
		</b-col>
	  </b-form-row>
	  <b-form-row>
        <b-col md="12">
          <label>Telefone:</label>
          <input
            class="form-control"
            type="text"
            v-mask="selecionaMascaraTelefone"
            v-model="pessoa.telefone"
			placeholder="Ex: (00) 00000-0000"
          />
        </b-col>
      </b-form-row>
	  <b-form-row class="mt-3" v-if="tipoPessoa == 'pessoaFisica'">
		<b-col md="12" class="d-flex gap-sm">
			<label>Funcionário Primeseg:</label>
    		<b-form-checkbox @input="limparTipoEspecifico" v-model="pessoa.funcionarioPrimeseg" :value="true" id="checkbox-funcionario">
    		</b-form-checkbox>
		</b-col>
	  </b-form-row>
      <div class="d-flex w-100 mt-3" style="justify-content:flex-start;">
        <b-button :disabled="carregandoSalvar" variant="success" @click="salvarPessoa">
            <b-spinner v-if="carregandoSalvar" variant="light"></b-spinner>
            <span v-if="!carregandoSalvar">Salvar</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import Pessoa from "../../model/Pessoa.js";
import PessoaService from "../../service/PessoaService.js";
import LocalidadesService from "../../service/LocalidadesService.js";
import AutoCompleteCidade from "../shared/AutoCompleteCidade.vue";

export default {
	components: { AutoCompleteCidade },
	name: "ModalSalvarPessoa",
	props: [ "usuario" ],
	data() {
		return {
			tipoPessoa: "pessoaJuridica",
			pessoa: new Pessoa(),
			idPessoa: 0,
			carregandoSalvar: false,
			carregandoBuscarPessoa: false,

			estados: [],
			cidades: [],

		};
	},
	computed: {
		selecionaMascaraTelefone() {
			return this.pessoa.telefone.length <= 14 ? "(##) ####-####" : "(##) #####-####";
		},
	},
	created() {
		this.buscarEstados();
	},
	methods: {
		limparTipoEspecifico() {
			if (this.pessoa.funcionarioPrimeseg) {
				this.pessoa.tipoEspecifico = "";
				this.pessoa.codigo = "";
			}
		},
		selecionaCidade(item) {
			this.pessoa.cidade = item;
		},
		buscarEstados() {
			let estadosLocais = [];
			LocalidadesService.listarEstados()
				.then((res) => {
					estadosLocais = res.data;
					this.estados = estadosLocais.map((e) => {
						const obj = {
							nome: e.nome,
							sigla: e.sigla,
						};
						return obj;
					 });
				}).catch(err => console.log(err));
		},
		abrirModal(id) {
			this.idPessoa = id;
			if (this.idPessoa != 0) {
				this.encontraPessoaPorId(this.idPessoa);
			}
			this.$bvModal.show("modal-salvar-pessoa");
		},
		validaFormularioNovaPessoa() {
			switch (this.tipoPessoa) {
			case "pessoaJuridica":
				return (
					this.pessoa.razaoSocial == ""
                     || this.pessoa.cnpj == ""
                     || this.pessoa.telefone == ""
					 || this.pessoa.cidade == ""
					 || this.pessoa.estado == ""
				);

			case "pessoaFisica":
				return (
					(this.pessoa.nome == ""
             || this.pessoa.cpf == ""
             || this.pessoa.telefone == ""
			 || this.pessoa.cidade == ""
			 || this.pessoa.estado == "")
				);

			default:
				return false;
			}
		},
		encontraPessoaPorId(id) {
			this.carregandoBuscarPessoa = true;
			PessoaService.consultarPessoaPorId(id)
				.then((res) => {
					this.pessoa = res.data;
					this.pessoa.telefone = this.$options.filters.addMascara(this.pessoa.telefone, "tel");
					this.verificaTipoPessoa(this.pessoa);
				}).catch((err) => {
					console.log(err);
				}).finally(() => {
					this.carregandoBuscarPessoa = false;
				});
		},
		salvarPessoa() {
			if (this.idPessoa == 0) {
				this.cadastrarNovaPessoa();
			} else {
				this.atualizarPessoa();
			}
		},
		atualizarPessoa() {
			this.carregandoSalvar = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));

			const pessoa = {
				nome: this.pessoa.nome,
    			razaoSocial: this.pessoa.razaoSocial,
    			cpf: this.$options.filters.removeMascara(this.pessoa.cpf),
    			cnpj: this.$options.filters.removeMascara(this.pessoa.cnpj),
    			telefone: this.$options.filters.removeMascara(this.pessoa.telefone),
				estado: this.pessoa.estado,
				cidade: this.pessoa.cidade,
				tipoEspecifico: this.pessoa.tipoEspecifico,
				codigo: this.pessoa.codigo,
				funcionarioPrimeseg: this.pessoa.funcionarioPrimeseg,
				idUsuarioResponsavel: usuarioLogado.id,
			};
			PessoaService.atualizarPessoa(pessoa, this.idPessoa)
				.then(() => {
					this.mensagem(
						"Pessoa Atualizada Com Sucesso!",
						"Sucesso",
						"success",
					);
					this.$emit("input");
					this.$bvModal.hide("modal-salvar-pessoa");
				}).catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível atualizar a pessoa!", "Erro", "danger");
					}
				}).finally(() => {
					this.carregandoSalvar = false;
				});
		},
		cadastrarNovaPessoa() {
			this.carregandoSalvar = true;

			if (this.validaFormularioNovaPessoa()) {
				this.mensagem("Todos os campos são obrigatórios", "Aviso", "warning");
				this.carregandoSalvar = false;
				return;
			}

			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));

			const pessoa = {
				nome: this.pessoa.nome,
    			razaoSocial: this.pessoa.razaoSocial,
    			cpf: this.$options.filters.removeMascara(this.pessoa.cpf),
    			cnpj: this.$options.filters.removeMascara(this.pessoa.cnpj),
    			telefone: this.$options.filters.removeMascara(this.pessoa.telefone),
				estado: this.pessoa.estado,
				cidade: this.pessoa.cidade,
				tipoEspecifico: this.pessoa.tipoEspecifico,
				codigo: this.pessoa.codigo,
				funcionarioPrimeseg: this.pessoa.funcionarioPrimeseg,
				idUsuarioResponsavel: usuarioLogado.id,
			};

			PessoaService.cadastrarPessoa(pessoa)
				.then(() => {
					this.mensagem(
						"Pessoa Cadastrada Com Sucesso!",
						"Sucesso",
						"success",
					);
					this.$bvModal.hide("modal-salvar-pessoa");
				})
				.then(() => {
					this.$emit("input");
				})
				.catch((err) => {
					this.mensagem(err.response.data, "Erro", "danger");
				})
				.finally(() => {
					this.carregandoSalvar = false;
				});
		},
		limparFormulario() {
			this.tipoPessoa = "pessoaJuridica";
			this.pessoa = new Pessoa();
		},
		verificaTipoPessoa(pessoa) {
			switch (pessoa.cpf) {
			case null:
				this.tipoPessoa = "pessoaJuridica";
				break;
			default:
				this.tipoPessoa = "pessoaFisica";
			}
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/pessoa/ModalSalvarPessoa.vue